import { Box, BoxProps } from '@mui/material'
import { ReactNode, forwardRef } from 'react'

import { GRAY_1000 } from 'constants/styling/theme'

interface PreviewContainerProps extends Omit<BoxProps, 'children'> {
  children: ReactNode
  hasWorkspaceActiveSubscription: boolean
}

/**
 * Shared container component for photo studio preview areas
 * Simple container that provides background and basic styling
 */
export const PreviewContainer = forwardRef<HTMLDivElement, PreviewContainerProps>(({ children, hasWorkspaceActiveSubscription, sx, ...boxProps }, ref) => {
  return (
    <Box
      ref={ref}
      sx={{
        backgroundColor: GRAY_1000,
        height: '100%',
        width: '100%',
        position: 'relative',
        overflow: 'hidden',
        pointerEvents: !hasWorkspaceActiveSubscription ? 'none' : 'auto',
        display: 'flex',
        flexDirection: 'column',
        ...sx,
      }}
      {...boxProps}
    >
      {children}
    </Box>
  )
})
